<template>
  <li class="product-attribute">
    <p
      class="product-attr-title"
      style="font-size: 1.2rem; margin-block: 0.5rem ; font-weight:600"
    >
      {{ atrr.title }}
    </p>
    <p
      class="product-attr-value"
      style="font-size: 1.2rem; margin-block: 0.5rem ; font-weight:600"
    >
      {{ atrr.value }}
    </p>
  </li>
</template>

<script>
export default {
  name: "ProductDetail",
  props: { atrr: Object },
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/components/ProductAttribute/ProductAttribute.css);
</style>
